import { Stack } from '@mui/material'
import { Info } from '@phosphor-icons/react'
import { Modal, tokens } from 'ComponentLibrary'
import { IconButton } from 'ComponentLibrary/src/piazza/buttons/IconButton/IconButton'
import { Typography } from 'ComponentLibrary/src/piazza/text'
import { useState } from 'react'
import type { SensitivityMatrixCopy } from './SensitivityMatrix'

type SensitivityMatrixHeaderProps = {
    showInfoButton?: boolean
    copy: SensitivityMatrixCopy
}

export default function SensitivityMatrixHeader({ showInfoButton = false, copy }: SensitivityMatrixHeaderProps) {
    const [isInfoModalOpen, setIsInfoModalOpen] = useState<boolean>(false)

    return (
        <>
            <Stack width="100%" direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="headline3" color={tokens.ColorTextBoldest}>
                    {copy.title}
                </Typography>
                {showInfoButton && (
                    <IconButton variant="tertiary" icon={<Info weight="bold" />} onClick={() => setIsInfoModalOpen(true)} size={'small'} />
                )}
            </Stack>
            <Modal showCloseIcon onClose={() => setIsInfoModalOpen(false)} isOpen={isInfoModalOpen} title={copy.title}>
                <Stack direction="column" gap={tokens.SizingSpacing150}>
                    <Typography variant="headline3" color={tokens.ColorTextBoldest}>
                        {copy.infoTitle}
                    </Typography>
                    <Typography variant="textM" color={tokens.ColorTextDefault}>
                        {copy.infoText}
                    </Typography>
                </Stack>
            </Modal>
        </>
    )
}
